import { onStartScraping } from "src/ipc/onStartScraping/onStartScraping";

export const API = {
    onStartScraping
}